import { gql } from '@apollo/client';
import Fragments from './fragments';

export const GENERIC_ENTITY_FLOW_CHANGED = gql`
  subscription genericEntityFlowChanged {
    genericEntityFlowChanged {
      genericEntityFlow {
        ...genericEntityFlowItem
      }
      mainFlowExists
    }
  }
  ${Fragments.genericEntityFlowItem}
`;

export const GENERIC_ENTITY_FLOW_STATES_CHANGED = gql`
  subscription genericEntityFlowStatesChanged {
    genericEntityFlowStatesChanged {
      flowId
    }
  }
`;

export const GENERIC_ENTITY_FLOW_DELETED = gql`
  subscription genericEntityFlowDeleted {
    genericEntityFlowDeleted {
      deletedFlowId
    }
  }
`;
